import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import tokens from '@verifime/design-tokens';
import React from 'react';
import { SandboxedFileViewer } from '../SandboxedFileViewer';
import { TFilePreviewModalProps } from './types';

export const FilePreviewModal: React.FC<TFilePreviewModalProps> = ({
  open,
  onClose,
  fileUrl,
  mimeType,
  isPDF,
  enableZoom,
}) => {
  if (!fileUrl) return null;

  if (!mimeType && isPDF === undefined) {
    throw new Error('FilePreviewModal: mimeType prop is required');
  }
  const resolvedMimeType = mimeType ?? (isPDF ? 'application/pdf' : 'image/jpeg');
  const isVideo = resolvedMimeType.startsWith('video/');

  if (isVideo) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        aria-label="Liveness check video"
        PaperProps={{
          sx: {
            width: 720,
            maxWidth: 'calc(100vw - 80px)',
            bgcolor: '#000',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: 24,
            position: 'relative',
          },
        }}
        slotProps={{
          backdrop: { sx: { bgcolor: 'rgba(0, 0, 0, 0.5)' } },
        }}
      >
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 2,
            width: 36,
            height: 36,
            bgcolor: 'rgba(0, 0, 0, 0.55)',
            backdropFilter: 'blur(8px)',
            color: '#fff',
            transition: 'background 120ms',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.8)' },
          }}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <SandboxedFileViewer
          fileUrl={fileUrl}
          mimeType={resolvedMimeType}
          sx={{ width: '100%' }}
        />
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '90vh',
          height: '90vh',
          bgcolor: 'background.paper',
        },
      }}
    >
      <DialogTitle
        sx={{
          p: tokens.spacingBase,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            '&:hover': {
              bgcolor: 'grey.100',
            },
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ height: `calc(100% - ${tokens.spacing4xl})` }}>
        <SandboxedFileViewer
          fileUrl={fileUrl}
          mimeType={resolvedMimeType}
          sx={{ width: '100%', height: '100%' }}
          enableZoom={enableZoom}
        />
      </DialogContent>
    </Dialog>
  );
};
